import PageMain from './pages/PageMain';
import PageAbout from './pages/PageAbout';
import PageVacancies from './pages/PageVacancies';
import PageInternships from './pages/PageInternships';
import PageInternshipsCard from './pages/PageInternshipsCard';
import PageHelp from './pages/PageHelp';
import PageCompany from './pages/PageCompany';
import PageVacanciesCard from './pages/PageVacanciesCard';
import PageWorkers from './pages/PageWorkers';
import PageWorkerCard from './pages/PageWorkerCard';
import PageSuccessSubmit from './pages/PageSuccessSubmit';
// import PageRecommendations from './pages/PageRecommendations';
// import PageTest from './pages/PageTest';
import PageUnsubscribe from './pages/PageUnsubscribe';
import PageNotFound from './pages/PageNotFound';

const routes = [
  {
    path: '/success',
    component: PageSuccessSubmit,
  },
  {
    path: '/about',
    component: PageAbout
  },
  {
    path: '/vacancies',
    component: PageVacancies,
    // strict:true,
    exact: true
  },
  {
    path: '/vacancies/vacancy:vacanciesCard',
    component: PageVacanciesCard
  },
  {
    path: '/internships',
    // strict:true,
    component: PageInternships,
    exact: true
  },
  {
    path: '/internships/internship:internshipsCard',
    component: PageInternshipsCard
  },
  {
    path: '/help',
    component: PageHelp
  },
  {
    path: '/company:company',
    component: PageCompany
  },
  {
    path: '/workers',
    component: PageWorkers,
    // strict:true,
    exact: true
  },
  {
    path: '/workers/worker:workerCard',
    component: PageWorkerCard
  },
  // Страницы временно скрыты, пусть будут закомментированы
  // {
  //   path: '/recommendations',
  //   component: PageRecommendations
  // },
  // {
  //   path: '/test',
  //   component: PageTest
  // },
  {
    path: '/unsubscribe',
    component: PageUnsubscribe
  },
  {
    path: `/`,
    component: PageMain,
    exact: true
  },
  {
    component: PageNotFound
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js